module.exports = __webpack_public_path__ + "img/ok.80aa703d.svg";